import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './cl-tooltip2.js';
import { d as defineCustomElement$1 } from './cl-typography2.js';

const clDataTableCellCss = ":host(cl-data-table-cell){display:table-cell;max-width:var(--data-table-column-width);overflow:hidden;padding:var(--data-table-cell-padding, var(--data-table-padding, inherit));text-align:var(--data-table-text-align, left);text-overflow:ellipsis;vertical-align:middle}@supports (background: -webkit-named-image(i)){:host(cl-data-table-cell){border-bottom:var(--border-width) solid var(--data-table-border-color);transition:border-color var(--animation-duration-fast) ease-in-out}}:host(cl-data-table-cell) slot{display:inline;text-wrap:var(--data-table-text-wrap);white-space:var(--data-table-text-wrap)}:host(cl-data-table-cell) cl-tooltip{--tooltip-max-width:var(--data-table-tooltip-max-width)}";

const ClDataTableCell = /*@__PURE__*/ proxyCustomElement(class ClDataTableCell extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.resizeObserver = new ResizeObserver((entries) => {
      const isOverflowing = this.element.offsetWidth < this.element.scrollWidth;
      if (isOverflowing) {
        this.tooltipLabel = entries[0].target.innerHTML;
      }
      this.showToolTip = isOverflowing && this.tooltipLabel.length !== 0;
    });
    this.renderSlot = () => h("slot", { key: 'cl-data-table-cell-slot' });
    this.renderContent = () => {
      var _a;
      return this.showToolTip ? (h("cl-tooltip", Object.assign({}, (((_a = this.tooltipLabel) === null || _a === void 0 ? void 0 : _a.length) ? { label: this.tooltipLabel } : {}), { dark: true }), this.renderSlot())) : (this.renderSlot());
    };
    this.showToolTip = false;
    this.tooltipLabel = '';
    this.cellIndex = undefined;
  }
  /**
   * Initialize resize observer
   */
  connectedCallback() {
    /** TODO: Look for a way to optimize the addition of resizeobserver */
    this.resizeObserver.observe(this.element);
  }
  /**
   * Destroy resize observer
   */
  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }
  // Fix position of tooltip and make the props of tooltip available from this component
  render() {
    return this.renderContent();
  }
  get element() { return this; }
  static get style() { return clDataTableCellCss; }
}, [1, "cl-data-table-cell", {
    "cellIndex": [2, "cell-index"],
    "showToolTip": [32],
    "tooltipLabel": [32]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-data-table-cell", "cl-tooltip", "cl-typography"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-data-table-cell":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClDataTableCell);
      }
      break;
    case "cl-tooltip":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
    case "cl-typography":
      if (!customElements.get(tagName)) {
        defineCustomElement$1();
      }
      break;
  } });
}

export { ClDataTableCell as C, defineCustomElement as d };

//# sourceMappingURL=cl-data-table-cell2.js.map